import React from 'react'

export default function FootNote() {
  return (
    <footer>
       
       <div class="footNode">
        <span class="footName">Abhishek Verma</span>&nbsp;&hearts;&nbsp;<span>Lucknow</span>
    </div>
    </footer>
  )
}
